import { makeType } from "./ui/core/types"

import { parseOptions, initLog } from "./ui/core/base"

import { first, maybe } from "./ui/core/functions"

import UI from "./ui/core/ui"

const proto = {
  name: "SearchPanel",
  parseOptions,
  initLog,

  initialize(dom) {
    this.dom = dom
    // this.initLog ()
    this.parseOptions()

    this.dom = dom

    this.controls = dom.findByRole("open")

    // TODO: create a popup and add to dom
    this.target = first(document.findByRole("search-popup"))

    const glob = this
    this.controls.forEach((t) => t.addEvent("click", () => glob.show()))
  },

  show() {
    // send through dispatcher?
    if (this.target.behaviors.Popup) {
      const app = this.target.behaviors.Popup
      // app.getURL(this.dom.dataset.uri);
      app.show("zoomed")
    }

    maybe((terms) => terms.focus())(
      first([...document.getElementsByName("searchterms")])
    )
  },
}

const SearchPanel = makeType(proto)

UI.register("search-button", SearchPanel)
